import i18n from "@/i18n"

export default {
  path: "/orders",
  component: () => import("./index.vue"),
  name: "orders",
  meta: {
    title: "orders.title"
  }
}
